class TriggerController {
    constructor(root = document) {
       this.root = root;
       this.init();
    }
 
    init() {
       this.root.addEventListener("click", (e) => {
          const trigger = e.target.closest("[data-trigger]");
 
          if (!trigger) return;
        
          this.handleTrigger(trigger);
       });
    }
 
    handleTrigger(trigger) {
       const selector = trigger.dataset.trigger;
       const eventType = trigger.dataset.triggerEvent || "click";
 
       if (!selector) return;
 
       const target = this.root.querySelector(selector);
 
       if (!target) {
          console.warn(
             `[TriggerController] Target not found for selector: "${selector}"`
          );
          return;
       }
 
       this.dispatchEvent(target, eventType);
    }
 
    dispatchEvent(target, eventType) {
       const event = new Event(eventType, { bubbles: true, cancelable: true });
       target.dispatchEvent(event);
 
       if (eventType === "click" && typeof target.click === "function") {
          target.click();
       }
    }
}

document.addEventListener("DOMContentLoaded", () => {
   new TriggerController();
});